"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCartOutline = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconCartOutline = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.734 4.076H1.41v-2.15h3.926l1.044 3.5h16.21l-3.372 11.65H7.608l-3.874-13Zm3.287 3.5 2.19 7.35h8.391l2.128-7.35H7.02Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.045 21.608c.365.366.807.548 1.327.548.52 0 .963-.182 1.328-.547.365-.365.548-.807.548-1.327 0-.52-.182-.963-.547-1.328a1.806 1.806 0 0 0-1.327-.548c-.52 0-.963.183-1.328.547a1.806 1.806 0 0 0-.548 1.327c0 .52.182.963.547 1.328Zm9.918 0c.365.366.807.548 1.327.548.52 0 .963-.182 1.328-.547.365-.365.548-.807.548-1.327 0-.52-.183-.963-.547-1.328a1.806 1.806 0 0 0-1.327-.548c-.52 0-.963.183-1.328.547a1.806 1.806 0 0 0-.548 1.327c0 .52.182.963.547 1.328Z"
}));
exports.IconCartOutline = IconCartOutline;
//# sourceMappingURL=IconCartOutline.js.map